import { PasswordPolicy } from '@acme/b2b/security';
import { ValidationErrors, ValidationFn } from '../validation-errors';
import { TODO } from '@b2b/types/core/utils';

function customPatternValidatorFactory(key: string, pattern: string | RegExp): ValidationFn {
  const regex = typeof pattern === 'string' ? new RegExp(pattern) : pattern;

  return (value: string) => {
    return regex.test(value) ? null : { [key]: {} };
  };
}

const atLeastOneLowercaseLetter = customPatternValidatorFactory('atLeastOneLowercaseLetter', /[a-z]/);
const atLeastOneUppercaseLetter = customPatternValidatorFactory('atLeastOneUppercaseLetter', /[A-Z]/);
const atLeastOneDigit = customPatternValidatorFactory('atLeastOneDigit', /[0-9]/);
const atLeastOneNonAlphabeticCharacter = customPatternValidatorFactory(
  'atLeastOneNonAlphabeticCharacter',
  /[^a-zA-Z0-9]/
);

export function passwordValidatorFactory(passwordPolicy: PasswordPolicy) {
  function atLeastPasswordMinimumLength(value: string): ValidationErrors | null {
    if (!!value && value.length >= passwordPolicy.passwordMinimumLength) {
      return null;
    }

    return { minlength: {} };
  }

  function passwordValidator(value: string | null | undefined): ValidationErrors | null {
    if (value == null || value === '') {
      return null;
    }

    let result: PasswordRequirementsValidationErrors = {};

    if (passwordPolicy.passwordMinimumLength > 0) {
      result = { ...result, ...atLeastPasswordMinimumLength(value) };
    }

    if (passwordPolicy.passwordUseMixedCase) {
      result = { ...result, ...atLeastOneLowercaseLetter(value), ...atLeastOneUppercaseLetter(value) };
    }

    if (passwordPolicy.passwordMinimumDigits > 0) {
      result = { ...result, ...atLeastOneDigit(value) };
    }

    if (passwordPolicy.passwordMinimumSymbols > 0) {
      result = { ...result, ...atLeastOneNonAlphabeticCharacter(value) };
    }

    return Object.keys(result).length === 0 ? null : result;
  }

  return passwordValidator;
}

export type PasswordRequirementsErrorType =
  | 'required'
  | 'minlength'
  | 'atLeastOneLowercaseLetter'
  | 'atLeastOneUppercaseLetter'
  | 'atLeastOneDigit'
  | 'atLeastOneNonAlphabeticCharacter';

export type PasswordRequirementsValidationErrors = Partial<Record<PasswordRequirementsErrorType, TODO>>;
